import { render, staticRenderFns } from "./Questionnaire.vue?vue&type=template&id=a2895dfa&scoped=true"
import script from "./Questionnaire.vue?vue&type=script&lang=js"
export * from "./Questionnaire.vue?vue&type=script&lang=js"
import style0 from "./Questionnaire.vue?vue&type=style&index=0&id=a2895dfa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2895dfa",
  null
  
)

export default component.exports